import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { AdministratorCompanyReadOnlySchema, SettingReadOnlySchema } from '@digitalforest/ngx-oak-api';
import { CompanyReadOnlySchema } from '@digitalforest/ngx-oak-api/lib/model/companyReadOnlySchema';

export const ScopeActions = createActionGroup({
  source: 'ScopeState',
  events: {
    LoadCompany: props<{ companyId: number }>(),
    LoadCompanySuccess: props<{
      company: CompanyReadOnlySchema;
      setting: SettingReadOnlySchema;
      administratorCompany: AdministratorCompanyReadOnlySchema;
    }>(),
    LoadCompanyFailure: props<{ error: unknown }>(),
    UnloadCompany: emptyProps(),
    UnloadCompanySuccess: emptyProps(),
    UnloadCompanyFailure: props<{ error: unknown }>(),
  },
});
